import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

//sections list
import { SectionListPageComponent } from '../pages/list.component';
import { InspectionSectionListComponent } from '../components/list.component';

//section detail
import { SectionDetailPageComponent } from '../pages/detail.component';
import { SectionDetailComponent } from '../components/detail.component';
import { routedComponents, SectionRoutingModule } from './section.routing';

import { SharedModule } from '../../shared.module';
import { SectionMenuComponent } from '../../menus/section.menu';
import { BrowserSharedModule } from '../../browser-shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, SectionRoutingModule, FormsModule, ReactiveFormsModule, BrowserSharedModule],
  declarations: [
    routedComponents,
    SectionListPageComponent,
    InspectionSectionListComponent,
    SectionDetailPageComponent,
    SectionDetailComponent,
    SectionMenuComponent
  ],
  exports: []
})
export class SectionModule {}
